<script setup>
import { h, isVNode } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  if (typeof props.icon === 'string' && props.icon.startsWith('http')) {
    return h('img', { src: props.icon, class: 'w-4 h-4', alt: '' });
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
